import React from 'react';
import { BreadcrumbItem } from '~/src/types/clioDocumentPicker';

interface DocumentPickerNavigationProps {
  breadcrumbs?: BreadcrumbItem[];
  onNavigate: (folderId: number | null) => void;
  onBack: () => void;
  canGoBack: boolean;
  isSearchMode: boolean;
}

export const DocumentPickerNavigation: React.FC<
  DocumentPickerNavigationProps
> = ({ breadcrumbs = [], onNavigate, onBack, canGoBack, isSearchMode }) => {
  return (
    <div className="px-6 pt-3 pb-2">
      <div className="flex items-center justify-between">
        {/* Left side - Breadcrumbs and Back button */}
        <div className="flex items-center gap-2">
          {canGoBack && !isSearchMode && (
            <button
              onClick={onBack}
              className="p-1 hover:bg-gray-200 rounded transition-colors"
              aria-label="Go back"
            >
              <svg
                className="w-4 h-4 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
          )}

          {/* Breadcrumbs */}
          <nav className="flex items-center space-x-1 text-sm">
            {isSearchMode ? (
              <span className="text-gray-600">Search Results</span>
            ) : (
              <div className="flex items-center">
                {breadcrumbs.map((item, index) => (
                  <div key={item.id} className="flex items-center">
                    {index > 0 && (
                      <svg
                        className="w-4 h-4 text-gray-400 mx-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                    {index === breadcrumbs.length - 1 ? (
                      <span className="text-gray-900 font-medium">
                        {index === 0 ? 'All files and folders' : item.name}
                      </span>
                    ) : (
                      <button
                        onClick={() => {
                          // First breadcrumb (root) should go to top-level view
                          onNavigate(index === 0 ? null : item.id);
                        }}
                        className="text-blue-600 hover:text-blue-800 hover:underline"
                      >
                        {index === 0 ? 'All files and folders' : item.name}
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};
